<template>
  <g
    :id="id"
    v-if="paths.length > 1"
    class="country"
    @mouseover="onHoverEvent"
    @mouseout="onMouseOut"
    @click="changeActiveCountry"
  >
    <path v-for="(path, i) in paths" :key="i" :d="path"></path>
  </g>
  <path
    :id="id"
    v-else
    class="country"
    :d="paths[0]"
    @mouseover="onHoverEvent"
    @mouseout="onMouseOut"
    @click="changeActiveCountry"
  ></path>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Country',
  props: {
    id: {
      type: Number
    },
    bbox: {
      required: true,
      type: Object
    },
    paths: {
      required: true,
      type: Array
    }
  },
  methods: {
    ...mapMutations({
      setActiveCountryId: 'mapStore/setActiveCountryId'
    }),
    onHoverEvent() {
      this.$emit('mouse-over');
    },
    onMouseOut() {
      this.$emit('mouse-out');
    },
    changeActiveCountry() {
      this.setActiveCountryId(this.id);
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
#HU {
  fill: rgba(94, 196, 230, 1);
}
.country {
  stroke: #0f2133;
  stroke-width: 0.1px;
  fill: rgba(94, 196, 230, 0.39);
  pointer-events: all;
  cursor: pointer;
  &:hover {
    fill: rgba(94, 196, 230, 0.6);
  }
}
</style>
